import axios from "axios";

import { instance, instanceUpload } from "../services/axiosConfig";
import instancemm from "../services/axiosConfigMM";
import { getDeviceInfo } from "../utils/editorUtils/editorUtils";

const apiErrorHandling = (err) => {  
  // if(err?.code == "ERR_NETWORK") {
  //   sessionStorage.setItem("backendFailed", "true");
  //   window.location.href = "/server-maintenance";
  //   return false;
  // }
  return true;
}

export const createeDetail = (payLoad, cb) => {
  instance
    .post(`decks?defaultSlide=true&type=${payLoad.type}`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// export const getPageDetails = (pageId, cb) => {
//   instance
//     .get(``)
//     .then((response) => {
//       cb(response);
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

// export const getAllPagesByeDetailName = (eDetailId, cb) => {
//   return instance
//     .get(` `)
//     .then((response) => {
//       cb(response);
//       return response.data;
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

// export const savePageDetails = (payLoad, pageId, cb) => {
//   return instance
//     .post(``, payLoad)
//     .then((response) => {
//       cb(response);
//       return response.data;
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

// export const deletePage = (moduleId, payload, cb) => {
//   instance
//     .delete(``, { data: payload })
//     .then((response) => {
//       cb(response);
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

// export const uploadVisual = (formData, options, cb) => {
//   instance
//     .post("", formData, options)
//     .then((response) => {
//       cb(response);
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

// export const getAlleDetail = (
//   eDetailId,
//   categoryType,
//   start,
//   limit,
//   created,
//   cb
// ) => {
//   return instance
//     .get(
//       `decks?skip=${start}&limit=${limit}&type=${categoryType}&created=${created}`
//     )
//     .then((response) => {
//       cb(response);
//       return response.data;
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };
export const getAlleDetail = ({
  eDetailId,
  type,
  start,
  limit,
  created,
  expired,
  callBack,
}) => {
  return instance
    .get(
      `decks?skip=${start}&limit=${limit}&type=${type}&created=${created}&expired=${expired}`
    )
    .then((response) => {
      callBack(response);
      return response.data;
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      callBack("", err, errorCode);
    });
};

export const getSlideDetailsById = (eDetailId, cb) => {
  return instance
    .get(`slides/${eDetailId}`)
    .then((response) => {
      cb(response);
      return response.data;
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// export const getPageDetail = (eDetailId, cb) => {
//   return instance
//     .get(`slides/62d6c449ad6faa5b18eb26f6`)
//     .then((response) => {
//       cb(response);
//       return response.data;
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

export const updatSlideData = (slideId, payload, cb) => {
  instance
    .patch(`/slides/${slideId}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const createNewPage = (payLoad, cb) => {
  instance
    .post("slides", payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const createNewPageUpdate = (deckId, payLoad, cb) => {
  instance
    .patch(`decks/insert/slide/${deckId}`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const searchForDetails = (searchPayload, cb) => {
  instance
    .get(
      //  `decks/search?brand=${searchPayload.brand}&market=${searchPayload.market}&campaign=${searchPayload.campaign}&name=${searchPayload.searchInput}&type=${searchPayload.type}&device=${searchPayload.device}&dimension=${searchPayload.dimension}&skip=0&limit=100`
      `decks/search?${
        searchPayload.brand ? `brand=${searchPayload.brand}&` : ""
      }${searchPayload.market ? `market=${searchPayload.market}&` : ""}${
        searchPayload.campaign ? `campaign=${searchPayload.campaign}&` : ""
      }${
        searchPayload.searchInput ? `name=${searchPayload.searchInput}&` : ""
      }${searchPayload.type ? `type=${searchPayload.type}&` : ""}${
        searchPayload.device ? `device=${searchPayload.device}&` : ""
      }${
        searchPayload.dimension ? `dimension=${searchPayload.dimension}&` : ""
      }skip=${searchPayload.skip}&limit=${searchPayload.limit}
      &created=${searchPayload.created}${
        searchPayload.expired
          ? `&expired=${searchPayload.expired}&`
          : "&expired=false"
      }${searchPayload.locked === false ? "&locked=false" : ""}${
        searchPayload.mlrStatus ? `&mlrStatus=${searchPayload.mlrStatus}&` : ""
      }${
        searchPayload.indication ? `indication=${searchPayload.indication}&` : ""
      }${
        searchPayload.contentType ? `tags=${searchPayload.contentType}` : ""
      }
   `
    )
    // .get(`decks/search?${searchString}&skip=0&limit=100`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const deleteEdetail = (eDetailId, cb) => {
  instance
    .delete(`decks/${eDetailId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// export const searchByFilterDetails = (searchPayload, type, cb) => {
//   instance
//     .get(
//       `decks/search?brand=${searchPayload.brand}&market=${searchPayload.market}&campaign=${searchPayload.campaign}&name=${searchPayload.searchInput}&type=${type}&device=${searchPayload.device}&skip=0&limit=10`
//     )
//     .then((response) => {
//       cb(response);
//     })
//     .catch((err) => {
//       const errorCode = err.response && err.response.status;
//       cb("", err, errorCode);
//     });
// };

export const cloneTemplateApi = (deckid, templatePayload, cb) => {
  instance
    .put(`decks/clone/${deckid}`, templatePayload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getBrandDetails = (cb) => {
  instance
    .get("resources?resource=brand")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getMarketDetails = (cb) => {
  instance
    .get("resources?resource=market&limit=1000")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getCampaignDetails = (cb) => {
  instance
    .get("resources?resource=campaign")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getIndicationDetails = (cb) => {
  instance
    .get("resources?resource=indication")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getDocVeevaMetaDetails = (DeckId, cb) => {
  instance
    .get(`/veeva/veeva-doc-meta/${DeckId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};


export const geteDetailByID = async (eDetailID, cb, skipStatus=false) => {
  await instance
    .get(`decks/${eDetailID}${skipStatus?'?skipStatus=true':''}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const deleteSlidesRequest = (deckId, slideId, cb) => {
  instance
    .delete(`decks/remove/slide/${deckId}/${slideId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const deleteChildSlideFromMaster = (deckId, slideid, payload, cb) => {
  instance
    .delete(`decks/remove/slide/${deckId}/${slideid}?scope=child`, {
      data: payload,
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const createNewChildSlide = (deckId, payload, cb) => {
  instance
    .patch(`decks/insert/slide/${deckId}?scope=child`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const uploadVideoDragAndDrop = (slideId, formData, cb, onProgress, cancelToken) => {
  instance
    .post(`resources/deck/${slideId}/upload-shared`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          // const percentCompleted = Math.round(
          //   (progressEvent.loaded * 100) / progressEvent.total
          // );
          const percentCompleted = ((progressEvent.loaded * 100) / progressEvent.total).toFixed(2);
          onProgress(percentCompleted);
        }
      },
      cancelToken, // pass the cancel token here
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      // Check if canceled
      if (axios.isCancel(err)) {
        console.log('Upload canceled');
      }
      cb("", err, errorCode);
    });
};

export const updateSlidesWithPosterUpload = (payLoad, cb) => {
  instance
    .post("slides/update-slides-after-poster-upload", payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const updateSlidesWithPosterDelete = (payLoad, cb) => {
  instance
    .post("slides/update-slides-after-poster-delete", payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const uploadAnImageDragAndDrop = (formData, cb) => {
  instance
    .post(`resources/upload`, formData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getImageLists = (cb) => {
  instance
    .get(`resources/list`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const AddMasterSlideToDeck = (slideId, payload, cb) => {
  instance
    .patch(`decks/insert/slide/${slideId}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const ExportDeckToMail = (DeckId, cb, preview) => {
  let urlPreview = preview
    ? `/decks/export/${DeckId}?preview=true`
    : `/decks/export/${DeckId}`;
  instance
    .get(urlPreview)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getImcToken = (cb) => {
 cb("");
};

export const imcSearchContentModules = (payload, cb) => {
  instancemm
    .post(`/modulems/contentstudio/contentmodules/search`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getCategories = (token, cb) => {
  axios
    .get(
      `https://nccamodule-api-gilead-qa.indegene.com/api/modulems/contentstudio/contentmodules/categories`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getVeevaRuleset = (payload, cb) => {
  instancemm
    .post(`/modulems/contentstudio/contentmodules/ruleset`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const updateDeckInfo = (deckId, payload, cb) => {
  instance
    .patch(`decks/${deckId}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getContentModuleCardinfo = (payload, cb) => {
  instancemm
    .post(`/modulems/contentstudio/contentmodules/cardinfo`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};
export const sendModuleCardtoEditor = (payload, cb) => {
  instance
    .post(`/metadata`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};
export const updateModuleCardsinEditor = (deckid, payload, cb) => {
  instance
    .patch(`/metadata/${deckid}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};
export const getVeevaLinkedModulesList = (cb) => {
  instance
    .get(`/metadata`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getVeevaLinkedModulesListByid = (deckid, cb) => {
  instance
    .get(`/metadata/${deckid}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getVeevaModuleDetails = (cardId, cb) => {
  instancemm
    .get(`/modulems/contentstudio/contentmodules/${cardId}`)

    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const PDFPreview = (DeckId, cb) => {
  instance
    .get(`/decks/export/${DeckId}?pdf=true`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const PublishToVeeva = (DeckId, payLoad, cb) => {
  instance
    .post(`/veeva/${DeckId}/publish`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const PublishHTMLAndPDF = (DeckId, cb) => {
  instance
    .get(`/decks/export/${DeckId}?publishZip=true`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
// decks/export/6801f6b81602b7fe811039bf?publishZip=true

export const getMLRStatus = (DeckId, publishMLRValue, cb) => {
  let x = publishMLRValue === true ? `?publishMLR=${publishMLRValue}` : "";
  instance
    .get(`/veeva/${DeckId}/sync${x}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getMarketList = (cb) => {
  instance
    .get(`/country`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getDeviceDetails = (cb) => {
  instance
    .get(`resources?resource=device&limit=${100}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};
export const getDimensionDetails = (cb) => {
  instance
    .get(`resources?resource=dimension&limit=${100}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getDAMSSearchResults = (DeckId, searchedText, cb) => {
  instance
    .get(`/veeva/${DeckId}/search-images?searchText=${searchedText}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const postListofImages2Veeva = (payLoad, brandID, cb) => {
  instance
    .post(`/veeva/${brandID}/import-images`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const searchLibraries = (searchedLibraries, cb) => {
  instance
    .get(`resources/import-library?searchText=${searchedLibraries}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getUpdatedLibrariesList = (id, payload, cb) => {
  instance
    .put(`resources/update-libraries/${id}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getNextaModuleDetails = (cardId, cb) => {
  instancemm
    .get(`/modulems/brands/${cardId}/categoryclaims`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getNextModuleBrandsCampaigns = (cb) => {
  instancemm
    .get(`/modulems/assets/brandcampaigns`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getNextaModulecardDetails = (payload, cb) => {
  instancemm
    .post(`/modulems/contentstudio/modules/search`, payload) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getBusinessRulesModuleManager = (payload, cb) => {
  instancemm
    .post(`/modulems/contentstudio/modules/businessrules`, payload) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const postAddCutomScripts = (payLoad, deckid, slideID, cb) => {
  instance
    .post(`resources/custom-script/${deckid}/${slideID}?remove=false`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const postRemoveCutomScripts = (payLoad, deckid, cb) => {
  instance
    .post(`/resources/custom-script/${deckid}/slideid?remove=true`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getAllScripts = async (slideid, cb) => {
  await instance
    .get(`/slides/${slideid}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const postModuleList = (payload, cb) => {
  instancemm
    .post(`/modulems/contentstudio/modules/claimcategory`, payload) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getMMCardInfo = (ID, cb) => {
  instancemm
    .get(`/modulems/modules/${ID}`) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const lockCardTemplate = ({ id, lock }, cb) => {
  instance
    .patch(`decks/lock-unlock/${id}`, {
      lock: lock,
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getDeckTraceabilityMatrix = (deckId, cb) => {
  instance
    .get(`/decks/traceability-matrix/${deckId}`) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getExpireDetails = ({ deckId, expired }, cb) => {
  instance
    .patch(`decks/expire/${deckId}`, {
      expire: expired,
    }) // {{URL}}/api/{{VER}}/decks/expire/643f825846ba4a5b8473b0d2
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const postZipPackage = (deckId, payLoad, cb) => {
  instance
    .post(`/resources/upload/html-zip/${deckId}`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const cloneSlide = (slideId, slideName, cb) => {
  instance
    .put(`/slides/clone/${slideId}`, { slideName })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const postFontFiles = (payLoad, cb) => {
  instance
    .post(`/resources/upload-fonts`, payLoad, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getFontlist = (deckId, cb) => {
  instance
    .get(`/decks/${deckId}/fonts`) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

// {{URL}}/api/{{VER}}/decks/:deckid/uploaded-docs?type=pdf
export const getUploadDocumentlist = (deckId, cb) => {
  instance
    .get(`/decks/${deckId}/uploaded-docs?type=pdf`) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

// https://cida-api-dev.indegene.com/api/v1/resources/65c08cb43e6986c128f29d17/upload-pdf
export const uploadDocumentFiles = (deckId, payLoad, cb) => {
  instance
    .post(`/resources/${deckId}/upload-pdf`, payLoad, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// API: {{URL}}/api/{{VER}}/resources/:deckId/:docId?type=pdf

export const deleteUploadedDocument = (deckId, docId, cb) => {
  // console.log(deckId, 'fgfg', docId);
  instance
    .delete(`/resources/${deckId}/${docId}?type=pdf`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      console.log(err);
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const uploadLink = (payLoad, cb) => {
  instance
    .post(`/documents/link-unlink`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const uploadSharedFiles = (deckId, payLoad, cb) => {
  // const { fonts, deckId } = payLoad;
  instance
    .post(`resources/deck/${deckId}/upload-shared`, payLoad, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const deleteSharedFiles = (payLoad, cb) => {
  const { list, deckId } = payLoad;
  instance
    .delete(
      `decks/${deckId}/remove-shared-assets`,
      { data: list },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getDeckGlobalCss = (deckId, payLoad, removeFlag, cb) => {
  instance
    .post(
      `resources/deck/${deckId}/upload-global-assets?remove=${removeFlag}`,
      payLoad,
      { headers: { "Content-Type": "application/json" } }
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const clearSharedResources = (deckId, cb) => {
  instance
    .delete(`decks/${deckId}/remove-shared-assets?cancelAssets=true`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getPlugin = (cb) => {
  instance
    .get(`/resources?resource=library`) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

// Gilead Search Module API
// https://nccamodule-api-gilead-qa.indegene.com/api/modulems/integration/v1/modules?pageNo=0&pageSize=30
export const getmmModules = (payload, cb) => {
  instancemm
    .post(
      `/api/modulems/integration/v1/modules?pageNo=${payload.page}&pageSize=${payload?.pageSize || 100}`,
      {
        productName: payload.productName,
        countryName: payload.countryName,
        searchText: payload.searchText,
        topicName: payload.topicName,
        subtopicName: payload.subtopicName,
        segmentNames: payload.segmentNames,
      }
    )
    .then((response) => {
      cb(response);
      // console.log("Response IDs", response.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getMlrStatusList = (cb) => {
  instance
    .get("resources?resource=status")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      if(!apiErrorHandling(err)) {
        return;
      }
      cb("", err, errorCode);
    });
};

export const getSelectedModulecardDetails = (id, cb) => {
  //https://nccamodule-api-gilead-qa.indegene.com/api/modulems/integration/v1/modules/a47e3a37-4903-454c-9333-e5659e494e09
  instancemm
    .get(`api/modulems/integration/v1/modules/businessRules/${id}`) ///modulems/contentstudio/modules/search
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const getModuleCardDetails = (id, cb) => {
  instancemm
    .get(`api/modulems/integration/v1/modules/${id}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};

export const updateModuleCardsEditor = (deckid, payload, cb) => {
  instance
    .post(`/metadata`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    });
};
//decks/validate/name?type=1
export const validateDeckName = async(payload, type) => {
  /* instance
    .post(`/decks/validate/name?type=${type}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(undefined, err, err.response && err.response.status);
    }); */
  try {
    const response = await instance.post(`/decks/validate/name?type=${type}`, payload);
    return response.data
  } catch (error) {
    throw error;
  }
};
export const verifyDeckName = async(payload, type, cb) => {
  instance
    .post(`/decks/validate/name?type=${type}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getSharedFileFromTemp = (payLoad, cb) => {
  const { deckId, templateId } = payLoad;
  instance
    .patch(`decks/${deckId}/copy-assets-update-slides`, {
      sourceDeckId: templateId,
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const postBinder = (id, payLoad, cb) => {
  instance
    .post(`/veeva/${id}/publish-zip/binder`, payLoad)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
      console.log(err);
    });
};

///api/v1/veeva/check/dams-ids
export const validateDAMS = (payLoad, cb) => {
  instance
    .post(`/veeva/check/dams-ids`, payLoad)
    .then((response) => {
      cb(response, null, 200);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
      console.log(err);
    });
};

export const PublishHTMLAndPDFBinder = (DeckId, cb) => {
  instance
    .get(`veeva/${DeckId}/sync/binder-status`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getPromomatsId = (queryParam, cb) => {
  const { type, brand, market } = queryParam;
  instance
    .get(`veeva/veeva-documents?type=${type}&veevaProductId=${brand}&veevaCountryId=${market}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getTrackChangesDetails = (id, cb) => {
  // const { type, brand, market } = queryParam;
  instance
    .get(`slides/trackChanges/${id}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};


//decks/template-preview/67ff9c5f71e0e56f203f3b35

export const openPdfRsdPreview = (id, cb) => {
  // const { type, brand, market } = queryParam;
  instance
    .get(`decks/template-preview/${id}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getVeevaApprovedDocs = (queryParams, cb) => {
  // Build query string from params
  const params = new URLSearchParams();
  if (queryParams.product) params.append("product", queryParams.product);
  if (queryParams.country) params.append("country", queryParams.country);
  if (queryParams.indication)
    params.append("indication", queryParams.indication);
  if (queryParams.docName) params.append("docName", queryParams.docName);

  instance
    .get(`pdf-html/veeva-approved-docs?${params.toString()}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// PDF → HTML Deck Creation API (e-Detail)
// POST /api/v2/decks/pdf-deck?defaultSlide=false&type=2
export const createPdfDeck = (payload, cb) => {
  // Replace v1 with v2 in the baseURL for this specific call
  const baseURL = instance.defaults.baseURL.replace("/api/v1/", "/api/v2/");
  const route = `decks/pdf-deck?defaultSlide=false&type=2`;
  const fullUrl = baseURL + route;
  // console.log("Creating PDF deck with route:", route);
  // console.log("Full URL:", fullUrl);
  // console.log("Payload:", payload);

  // Use axios directly with the full URL to avoid baseURL duplication
  // Manually add auth headers (normally added by interceptors)
  const token = window.localStorage.getItem("userToken");

  const config = {
    timeout: instance.defaults.timeout,
    headers: {
      ...instance.defaults.headers.common,
      ...(token && { Authorization: `Bearer ${token}` }),
      "device-info": getDeviceInfo(),
    },
  };

  axios
    .post(fullUrl, payload, config)
    .then((response) => {
      // console.log("PDF deck creation success:", {
      //   status: response.status,
      //   data: response.data,
      // });
      cb(response, null, null);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      console.error("PDF deck creation error:", {
        error: err,
        errorCode,
        response: err.response?.data,
      });
      cb(null, err, errorCode);
    });
};

export const getVeevaPdfFile = (docId, minorVersion, majorVersion, cb) => {
  // Updated endpoint: GET: /pdf-html/veeva-document?docId={docId}&minorVersion={minorVersion}&majorVersion={majorVersion}
  const params = new URLSearchParams();
  params.append("docId", docId);
  if (minorVersion !== undefined && minorVersion !== null) {
    params.append("minorVersion", minorVersion);
  }
  if (majorVersion !== undefined && majorVersion !== null) {
    params.append("majorVersion", majorVersion);
  }
  const route = `pdf-html/veeva-document?${params.toString()}`;
  const fullUrl = instance.defaults.baseURL + route;
  // console.log("Fetching PDF from route:", route);
  // console.log("Full URL will be:", fullUrl);
  // console.log(
  //   "DocId:",
  //   docId,
  //   "MinorVersion:",
  //   minorVersion,
  //   "MajorVersion:",
  //   majorVersion
  // );

  instance
    .get(route, {
      responseType: "json", // Changed from "blob" to "json" as API now returns JSON with fileUrl
    })
    .then((response) => {
      // console.log("PDF fetch success:", {
      //   status: response.status,
      //   data: response.data,
      // });
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      const requestUrl = err.response?.config?.url || err.config?.url;
      console.error("PDF fetch error:", {
        errorCode,
        requestUrl,
        docId,
        message: err.message,
        fullError: err,
      });
      cb("", err, errorCode);
    });
};

export const getNotifications = (cb) => {
  instance
    .get(`/notifications`)
    .then((response) => {
      cb(response, null, null);
    })
    .catch((err) => {
      cb(null, err, err.response && err.response.status);
    });
};

export const markAsRead = (id, cb) => {
  instance
    .patch(`/notifications/mark-read${id ? "/"+id : ""}`, {})
    .then((response) => {
      cb(response, null, null);
    })
    .catch((err) => {
      cb(null, err, err.response && err.response.status);
    });
};
